export default "__VITE_ASSET__B_nViE4m__"